import { createAction, props } from '@ngrx/store';

export const shareReport = createAction(
  '[Report] Share Report',
  props<{ email: string, search_id: number }>()
);

export const shareReportSuccess = createAction(
  '[Report] Share Report Success'
);

export const shareReportFailure = createAction(
  '[Report] Share Report Failure',
  props<{ error: any }>()
);


export const editPrompt = createAction(
  '[Report] Edit Prompt',
  props<{ search_id: string, assistant_prompt_id: string, prompt_value: string }>()
);

export const editPromptSuccess = createAction(
  '[Report] Edit Prompt Success',
  props<{ response: any }>() // Customize the response as needed
);

export const editPromptFailure = createAction(
  '[Report] Edit Prompt Failure',
  props<{ error: any }>()
);

export const refineIcpScore = createAction(
  '[ICP Score] Refine ICP Score',
  props<{ searchCompanyId: number, selectedValues: any, formValues: any }>()
);

export const refineIcpScoreSuccess = createAction(
  '[ICP Score] Refine ICP Score Success',
  props<{ result: any }>()
);

export const refineIcpScoreFailure = createAction(
  '[ICP Score] Refine ICP Score Failure',
  props<{ error: any }>()
);

export const changeCompany = createAction(
  '[Report] Change Company',
  props<{ searchId: number, organizationId: string }>()
);

export const changeCompanySuccess = createAction(
  '[Report] Change Company Success',
  props<{ response: any }>()
);

export const  changeCompanyFailure = createAction(
  '[Report] Change Company Failure',
  props<{ error: any }>()
);

export const clearChangeCompanyState = createAction(
  '[Report] Clear Change Company State'
);

export const updateCompany = createAction(
  '[Report] Update Company',
  props<{ company: any }>()
);

export const clearAssistantPrompts = createAction(
  '[Report] Clear Assistant Prompts'
);

export const updateReportStatusInStore = createAction(
  '[Report] Update Report Status In Store',
  props<{ statusId: number }>()
);
